import makeStyles from '@mui/styles/makeStyles';
import withStyles from '@mui/styles/withStyles';
import { Skeleton } from '@mui/material';
import { appPalette } from 'theme/App.palette';
import { theme } from 'theme/App.theme';

const colors = appPalette.colors;

export const WhiteSkeleton = withStyles({
  root: {
    backgroundColor: 'rgba(255, 255, 255, 0.3)',
  },
})(Skeleton);

export const useStyles = makeStyles({
  root: {
    flexGrow: 1,
    margin: '0 auto',
    padding: '0 1rem',
  },
  location: {
    width: '100%',
    height: '2.25rem',
  },
  header: {
    width: 'calc(100vw - 1.875rem)',
    padding: '1.5625rem 0',
    [theme.breakpoints.up('viewportLarge')]: {
      width: '40%',
      padding: '3.125rem 0 3.75rem',
    },
    [theme.breakpoints.up('viewportXLarge')]: {
      width: '35%',
    },
  },
  header_title: {
    width: '50%',
    height: '3.75rem',
    marginBottom: '1.875rem',
  },
  header_description: {
    width: '100%',
    height: '1.125rem',
    [theme.breakpoints.up('viewportLarge')]: {
      '&:last-child': {
        width: '30%',
      },
    },
  },
  filter_dropdown: {
    margin: '0 auto',
    marginBottom: '1.25rem',
    width: 'calc(100vw - 1.875rem)',
    height: '3rem',
    [theme.breakpoints.up('viewportMedium')]: {
      width: '100%',
    },
  },
  zip_input: {
    margin: '0 auto',
    marginBottom: '2.25rem',
    width: 'calc(100vw - 1.875rem)',
    height: '2.25rem',
    [theme.breakpoints.up('viewportMedium')]: {
      width: '100%',
    },
  },
  tab_container: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    maxWidth: '18.75rem',
    margin: '0 auto',
  },
  tab: {
    width: '50%',
    height: '3.75rem',
  },
  white_tab: {
    border: `0.0625rem solid ${colors}`,
    boxShadow: '0 3px 10px 1px rgb(0 0 0 / 21%)',
  },
  card: {
    width: 'calc(100vw - 1.875rem)',
    height: '14.3125rem',
    marginTop: '0.9375rem',
    '&:last-child': {
      marginBottom: '1.5625rem',
    },
    [theme.breakpoints.up('viewportMedium')]: {
      width: '100%',
      margin: '0',
      marginTop: '0.9375rem',
    },
  },
  show_more: {
    width: 'calc(100vw - 1.875rem)',
    height: '3.125rem',
    margin: '0 auto',
    marginBottom: '0.625rem',
    [theme.breakpoints.up('viewportMedium')]: {
      width: '100%',
      marginTop: '1.25rem',
    },
  },
  main_container: {
    flexDirection: 'row',
    justifyContent: 'center',
  },
  dealer_container: {
    [theme.breakpoints.up('viewportMedium')]: {
      padding: '0 0.5rem !important',
    },
    [theme.breakpoints.up('viewportLarge')]: {
      maxWidth: '42%',
      minWidth: '28.4375rem',
    },
  },
  map: {
    width: 'calc(100% - 1.875rem)',
    margin: '0 auto',
    height: '100vh',
    maxHeight: '93.75rem',
    [theme.breakpoints.up('viewportMedium')]: {
      height: 'calc(100vh - 5em)',
      margin: '0',
      width: '100%',
    },
    [theme.breakpoints.up('viewportLarge')]: {
      height: 'calc(100vh - 7em)',
    },
  },
  map_container: {
    [theme.breakpoints.up('viewportLarge')]: {
      paddingLeft: '1.375rem',
    },
    [theme.breakpoints.up('viewportXLarge')]: {
      paddingLeft: '2rem',
    },
  },
});
